var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 60,
    viewBox: "0 0 48 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.7364,
    cy: 15.8341,
    rx: 14.3341,
    ry: 14.3341,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00005 50.1042C0.996197 49.0965 1.22156 48.1012 1.65909 47.1934C3.03209 44.4474 6.90394 42.992 10.1168 42.333C12.4338 41.8385 14.7829 41.5082 17.1465 41.3444C21.5225 40.9601 25.9238 40.9601 30.2998 41.3444C32.6632 41.5101 35.0122 41.8404 37.3296 42.333C40.5424 42.992 44.4142 44.3101 45.7872 47.1934C46.6671 49.0438 46.6671 51.192 45.7872 53.0424C44.4142 55.9257 40.5424 57.2438 37.3296 57.8753C35.0152 58.3903 32.6653 58.7299 30.2998 58.8914C26.7381 59.1933 23.1598 59.2483 19.5904 59.0561C18.7666 59.0561 17.9703 59.0561 17.1465 58.8914C14.7899 58.7319 12.449 58.3922 10.1442 57.8753C6.90394 57.2438 3.05954 55.9257 1.65909 53.0424C1.22379 52.1241 0.998656 51.1204 1.00005 50.1042Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProfile);
export default __webpack_public_path__ + "static/media/no_profile.cf6ada77b63e8e3ff5aa77fd490c7a41.svg";
export { ForwardRef as ReactComponent };